import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {FormFieldType} from "@pg-mono/form";
import {pick} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {fromJsonValues} from "../../form/translate/from_json_values";
import {getSentLeadFormValuesFromStorage} from "../../lead/utils/sent_lead_form_values";

export const formFields = {
    name: FormFieldType.Input,
    email: FormFieldType.Input,
    phone: FormFieldType.PhoneField
};

const defaultValues = {
    name: "",
    email: "",
    phone: {code: 48, number: ""}
};

export type formValuesType = typeof defaultValues;

export const useCalculatorFormInitialValues = (): formValuesType => {
    const [initialValues, setInitialValues] = useState<formValuesType>(defaultValues);

    const isAuthenticated = useSelector((state: IRPStore) => state.isAuthenticated);
    const userProfileDataFromStore = useSelector((state: IRPStore) => state.user.profile.data);

    useEffect(() => {
        const userProfileDataFromLocalStorage = getSentLeadFormValuesFromStorage();

        if (isAuthenticated) {
            const userProfileData = userProfileDataFromStore;

            // Fill application form with user data from API
            if (!!userProfileData) {
                setInitialValues((prev) => {
                    return {...prev, ...fromJsonValues(formFields, {...userProfileData})};
                });

                return;
            }
        }

        // Fill application form with user data from local storage
        if (!!userProfileDataFromLocalStorage) {
            setInitialValues((prev) => {
                return {
                    ...prev,
                    ...fromJsonValues(formFields, pick(userProfileDataFromLocalStorage, ["email", "name", "phone"]))
                };
            });
        }
    }, [isAuthenticated, userProfileDataFromStore]);

    return initialValues;
};
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {FormFieldType} from "@pg-mono/form";
import {pick} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {fromJsonValues} from "../../form/translate/from_json_values";
import {getSentLeadFormValuesFromStorage} from "../../lead/utils/sent_lead_form_values";

export const formFields = {
    name: FormFieldType.Input,
    email: FormFieldType.Input,
    phone: FormFieldType.PhoneField
};

const defaultValues = {
    name: "",
    email: "",
    phone: {code: 48, number: ""}
};

export type formValuesType = typeof defaultValues;

export const useCalculatorFormInitialValues = (): formValuesType => {
    const [initialValues, setInitialValues] = useState<formValuesType>(defaultValues);

    const isAuthenticated = useSelector((state: IRPStore) => state.isAuthenticated);
    const userProfileDataFromStore = useSelector((state: IRPStore) => state.user.profile.data);

    useEffect(() => {
        const userProfileDataFromLocalStorage = getSentLeadFormValuesFromStorage();

        if (isAuthenticated) {
            const userProfileData = userProfileDataFromStore;

            // Fill application form with user data from API
            if (!!userProfileData) {
                setInitialValues((prev) => {
                    return {...prev, ...fromJsonValues(formFields, {...userProfileData})};
                });

                return;
            }
        }

        // Fill application form with user data from local storage
        if (!!userProfileDataFromLocalStorage) {
            setInitialValues((prev) => {
                return {
                    ...prev,
                    ...fromJsonValues(formFields, pick(userProfileDataFromLocalStorage, ["email", "name", "phone"]))
                };
            });
        }
    }, [isAuthenticated, userProfileDataFromStore]);

    return initialValues;
};
